import {
  compact,
  concat,
  flatten,
  head,
  intersection,
  pipe,
  placeholder,
} from 'lodash/fp'

import { APP_LOCALE } from '../constants'

export const resolveLocale = pipe([
  flatten,
  compact,
  intersection(APP_LOCALE),
  concat(placeholder, APP_LOCALE),
  head,
])
